// The constants file itself, not @hmhco/platform-helper: the maps below read PLATFORMS when
// the module loads, and app tests mock platform-helper without it.
import { PLATFORMS } from '../../../../environments/globalConstants';

// Legacy flags (ed-s3 for Ed, hnm-ui-config for Flight) that move a district to Config Policy,
// the new flags library (AUTH-1462):
// - CONFIG_POLICY_FLAG: hcp-container loads the new library; isFlagEnabled answers from it.
// - CONFIG_POLICY_SERVE_FLAG: isFeatureActive answers from it too.
export const CONFIG_POLICY_FLAG = 'configPolicyServiceSdk';
export const CONFIG_POLICY_SERVE_FLAG = 'configPolicyServiceSdkServe';

// App name in the Config Policy registry.
export const CONFIG_POLICY_APP = 'lift';
// Config Policy platform of each Lift platform; others have no flags in the store.
export const CONFIG_POLICY_PLATFORMS = {
  [PLATFORMS.ED]: 'ed',
  [PLATFORMS.FLIGHT]: 'flight',
};
// Store domain of each Lift platform: the one its pages run on.
export const CONFIG_POLICY_DOMAINS = {
  [PLATFORMS.ED]: 'hmhco',
  [PLATFORMS.FLIGHT]: 'heinemann',
};

// The new flags library once loadConfigPolicy has started it with the flags; null before that.
let configPolicy = null;

export const getConfigPolicy = () => configPolicy;

/**
 * Checks a new flag (created in the Config Policy dashboard). False while hcp-container has not
 * loaded the new library for the user and for a flag the store does not have.
 * e.g. isFlagEnabled('newDashboard') // true when the store enables it
 */
export const isFlagEnabled = flagName =>
  configPolicy ? configPolicy.isEnabled(flagName) : false;

/**
 * Loads and starts the new flags library for the user. hcp-container calls it only when the
 * legacy CONFIG_POLICY_FLAG is on, so for everyone else the library never starts.
 * Rejects when the library cannot start or download the flags; the legacy flags keep answering then.
 *
 * @param {Object} userData - parsed user context (platform, env, userId, districtPid, userLocationState)
 */
export const loadConfigPolicy = async userData => {
  const platform = CONFIG_POLICY_PLATFORMS[userData.platform];
  const domain = CONFIG_POLICY_DOMAINS[userData.platform];
  if (!platform || !domain) return;

  const sdk = await import(
    /* webpackChunkName: "config-policy" */ '@hmh/poc-config-policy-service-js-sdk'
  );
  // The library's defaults (sessionStorage cache, polling, 3 s per download attempt) plus the
  // store and the user. requireInitialFetch: without the flags init rejects, so the library is
  // not used.
  await sdk.init({
    network: { domain },
    requireInitialFetch: true,
    context: {
      app: CONFIG_POLICY_APP,
      platform,
      env: userData.env,
      userId: userData.userId,
      districtPid: userData.districtPid,
      userLocationState: userData.userLocationState,
    },
  });
  configPolicy = sdk;
};
